import { Fragment } from 'react';

import TeamEntryManagementLargeGrid from './TeamEntryManagementLargeGrid';
import TeamEntryManagementSmallGrid from './TeamEntryManagementSmallGrid';

const TeamEntryManagementGrid = ({ gridData, isLoading, onAddEntryClicked, onEdit, onDeleteTeamEntryClicked, onView }) => {
  return (
    <Fragment>
      <TeamEntryManagementLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onAddEntryClicked={onAddEntryClicked}
        onEdit={onEdit}
        onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
        onView={onView}
      />
      <TeamEntryManagementSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onAddEntryClicked={onAddEntryClicked}
        onEdit={onEdit}
        onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
        onView={onView}
      />
    </Fragment>
  )
};

export default TeamEntryManagementGrid;